// @ts-nocheck
import useEmblaCarousel from "embla-carousel-react";
import {useCallback, useEffect, useRef, useState} from "react";

const heroCls =
  "relative w-full min-w-0 overflow-hidden bg-[var(--color-bg)] after:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-24 after:bg-[linear-gradient(to_bottom,transparent_0%,var(--color-bg)_100%)] after:pointer-events-none after:z-[1]";
const emblaViewportCls = "overflow-hidden w-full min-w-0";
const emblaContainerCls = "flex w-full items-center justify-start touch-pan-y min-w-0";
const emblaSlideCls =
  "flex-[0_0_100%] min-w-0 flex items-center justify-center cursor-pointer transition-transform duration-300 ease-in-out [&>img]:w-full [&>img]:h-auto [&>img]:block [&>img]:object-cover [&>img]:aspect-[1514/500]";
const dotsRowCls =
  "absolute left-1/2 -translate-x-1/2 bottom-3 z-[2] flex items-center gap-1.5 px-2.5 py-1.5 rounded-full bg-[rgba(0,0,0,0.4)] backdrop-blur-md ring-1 ring-[rgba(255,255,255,0.08)] max-[600px]:bottom-2";
const dotBaseCls =
  "h-1.5 rounded-full transition-[width,background-color,opacity] duration-300 ease-out cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-primary)] focus-visible:ring-offset-1 focus-visible:ring-offset-black/40";
const dotInactiveCls = "w-1.5 bg-[rgba(255,255,255,0.45)] hover:bg-[rgba(255,255,255,0.75)]";
const dotActiveCls = "w-6 bg-[var(--color-primary)]";
const arrowBaseCls =
  "hidden md:flex absolute top-1/2 -translate-y-1/2 z-[2] w-10 h-10 rounded-full items-center justify-center bg-[rgba(0,0,0,0.45)] text-white ring-1 ring-[rgba(255,255,255,0.1)] backdrop-blur-md transition-[opacity,background-color,transform] duration-200 opacity-0 group-hover/hero:opacity-100 hover:bg-[rgba(0,0,0,0.65)] hover:scale-105 active:scale-95 disabled:opacity-0 disabled:pointer-events-none cursor-pointer";

const SLIDE_DURATION_MS = 5000;

const options = {
  loop: false,
  align: "start",
  duration: 25,
  watchDrag: true,
};

const ChevronLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ChevronRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const PLACEHOLDER_SLIDES = [1, 2, 3];

export const PromoBanners = () => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options);
  const timeoutRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!emblaApi) return;

    const scheduleNext = () => {
      timeoutRef.current = setTimeout(() => {
        const selected = emblaApi.selectedScrollSnap();
        const next = (selected + 1) % PLACEHOLDER_SLIDES.length;
        emblaApi.scrollTo(next, false);
      }, SLIDE_DURATION_MS);
    };

    const onSelect = () => {
      setActiveIndex(emblaApi.selectedScrollSnap());
      scheduleNext();
    };

    emblaApi.on("select", onSelect);
    scheduleNext();

    return () => {
      emblaApi.off("select", onSelect);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [emblaApi]);

  const scrollTo = useCallback(
    (index: number) => {
      if (!emblaApi) return;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      emblaApi.scrollTo(index, false);
    },
    [emblaApi]
  );

  const scrollPrev = useCallback(() => {
    if (!emblaApi) return;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (!emblaApi) return;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    emblaApi.scrollNext();
  }, [emblaApi]);

  return (
    <section
      aria-label="Promociones destacadas"
      className={`group/hero ${heroCls}`}
    >
      <div
        className={emblaViewportCls}
        ref={emblaRef}
      >
        <div className={emblaContainerCls}>
          {PLACEHOLDER_SLIDES.map(n => (
            <div
              key={n}
              className="flex-[0_0_100%] min-w-0 flex items-center justify-center aspect-[1514/500] max-[600px]:aspect-[4/3] bg-[rgba(255,255,255,0.10)]"
            >
              <div className="flex flex-col items-center gap-3 select-none pointer-events-none">
                <div className="w-12 h-12 rounded-full border-2 border-dashed border-[rgba(255,255,255,0.2)] flex items-center justify-center">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" aria-hidden="true">
                    <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
                  </svg>
                </div>
                <span className="text-[rgba(255,255,255,0.3)] text-sm font-medium tracking-wide">
                  Aquí diseño slider
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button
        type="button"
        aria-label="Promoción anterior"
        className={`${arrowBaseCls} left-3`}
        onClick={scrollPrev}
      >
        <ChevronLeft />
      </button>
      <button
        type="button"
        aria-label="Siguiente promoción"
        className={`${arrowBaseCls} right-3`}
        onClick={scrollNext}
      >
        <ChevronRight />
      </button>

      <div
        className={dotsRowCls}
        role="tablist"
        aria-label="Selector de promociones"
      >
        {PLACEHOLDER_SLIDES.map((n, index) => (
          <button
            key={n}
            type="button"
            role="tab"
            aria-selected={index === activeIndex}
            aria-label={`Ir a la diapositiva ${index + 1}`}
            onClick={() => scrollTo(index)}
            className={`${dotBaseCls} ${index === activeIndex ? dotActiveCls : dotInactiveCls}`}
          />
        ))}
      </div>
    </section>
  );
};
